/**
 * Option lists the form offers, kept out of the form itself.
 *
 * Both of these are also the allow-list a *stored* preference is validated
 * against, and a preference read on a later visit can name something this build
 * no longer offers. Sharing the list is what keeps "what the form shows" and
 * "what may be restored" from drifting apart — the rest of the option lists
 * (`CHARACTERS`, `ASPECTS`, `VOICES`, `LANGUAGES`) already live next to their
 * own domain and are used the same way.
 */
import type { WatermarkCorner } from "./types";

export const DURATIONS = [
	{ seconds: 20, label: "20s" },
	{ seconds: 30, label: "30s" },
	{ seconds: 45, label: "45s" },
	{ seconds: 60, label: "60s" },
];

export const WATERMARK_CORNERS: Array<{
	value: WatermarkCorner;
	label: string;
}> = [
	{ value: "bottom-right", label: "Bottom right" },
	{ value: "bottom-left", label: "Bottom left" },
	{ value: "top-right", label: "Top right" },
	{ value: "top-left", label: "Top left" },
];
